import AccountLayout from '@/components/feature/AccountLayout';
import { notifications } from '@/mocks/news';

const typeStyle: Record<string, string> = {
  price: 'ri-line-chart-line text-primary-400 bg-primary-500/15',
  trade: 'ri-exchange-line text-emerald-400 bg-emerald-500/15',
  system: 'ri-settings-3-line text-foreground-400 bg-background-200/60',
  promo: 'ri-gift-line text-accent-400 bg-accent-500/15',
};

export default function Notifications() {
  return (
    <AccountLayout>
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-bold text-foreground-950">Trung tâm thông báo</h1>
          <button className="text-sm font-semibold text-primary-400 hover:text-primary-300 cursor-pointer whitespace-nowrap">
            Đánh dấu đã đọc tất cả
          </button>
        </div>

        <div className="space-y-3">
          {notifications.map((n) => (
            <div key={n.id} className={`rounded-xl border p-4 flex items-start gap-3 ${n.read ? 'border-background-200/60 bg-background-100' : 'border-primary-500/30 bg-primary-500/5'}`}>
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${typeStyle[n.type]}`}>
                <i className={`${typeStyle[n.type].split(' ')[0]} text-lg`}></i>
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <p className={`text-sm font-semibold text-foreground-950 ${n.read ? '' : 'text-primary-300'}`}>{n.title}</p>
                  {!n.read && <span className="w-2 h-2 rounded-full bg-primary-400"></span>}
                </div>
                <p className="text-sm text-foreground-600 mt-1">{n.message}</p>
                <p className="text-xs text-foreground-600 mt-2">{n.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AccountLayout>
  );
}